export const SPORT_TOGGLE_INPUT_LABEL = "Toggle Subjects";



// WEBPACK FOOTER //
// ./src/pages/director/SurveyDataCenter/components/SportCheckboxes/constants.ts